import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Issue from './issue-model'
import {
  CreateIssueAsync,
  DeleteIssueAsync,
  LoadIssuesAsync,
} from './issue-thunk'
const initialState: issueSliceState = {
  issue: [],
  selected_issue: '',
  is_loading_issue: false,
  is_creating_issue: false,
  is_deleting_issue: false,
}
export interface issueSliceState {
  issue: Issue[]
  selected_issue?: string
  is_loading_issue: boolean
  is_creating_issue: boolean
  is_deleting_issue: boolean
}
export const issueSlice = createSlice({
  name: 'issue',
  initialState,
  reducers: {
    setSelectedissue: (state, action) => {
      state.selected_issue = action.payload
    },
    clearStateissue: (state) => {
      state.issue = []
      state.is_loading_issue = false
      state.is_creating_issue = false
      state.is_deleting_issue = false
    },
    mergeissue: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_issue = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.issue = merge(state.issue, payload) as any
        }
      }
    },

    add_issue: (state, action) => {
      if (action.payload) {
        state.issue = [...state.issue, action.payload]
      }
    },
    set_issue: (state, action) => {
      let { key, value, id } = action.payload
      state.issue = state.issue.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadIssuesAsync.pending, (state) => {
      state.is_loading_issue = true
    })
    builder.addCase(LoadIssuesAsync.fulfilled, (state, action) => {
      state.is_loading_issue = false
      if (action.payload) {
        state.issue = action.payload
      }
    })
    builder.addCase(LoadIssuesAsync.rejected, (state) => {
      state.is_loading_issue = false
    })
    builder.addCase(CreateIssueAsync.pending, (state) => {
      state.is_creating_issue = true
    })
    builder.addCase(CreateIssueAsync.fulfilled, (state) => {
      state.is_creating_issue = false
    })
    builder.addCase(CreateIssueAsync.rejected, (state) => {
      state.is_creating_issue = false
    })
    builder.addCase(DeleteIssueAsync.pending, (state) => {
      state.is_deleting_issue = true
    })
    builder.addCase(DeleteIssueAsync.fulfilled, (state, action) => {
      state.is_deleting_issue = false
      if (state.issue) {
        state.issue = state.issue.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteIssueAsync.rejected, (state) => {
      state.is_deleting_issue = false
    })
  },
})

export const {
  clearStateissue,
  setSelectedissue,
  set_issue,
  mergeissue,
  add_issue,
} = issueSlice.actions

export const get_issue =
  (id?: string) =>
  (state: {
    issue: {
      issue: Issue[]
    }
  }): Issue | null => {
    let temp = state?.issue?.issue?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.issue?.issue[0] || null
  }
export const get_selected_issue = (state: {
  issue: issueSliceState
}): Issue | null => {
  let id = state?.issue?.selected_issue
  let temp = state?.issue?.issue?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_issue = (state: {
  issue: {
    issue: Issue[]
  }
}): Issue[] => {
  let temp = state?.issue?.issue
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_issue_busy = (state: { issue: issueSliceState }) => {
  return (
    state?.issue.is_deleting_issue ||
    state?.issue.is_loading_issue ||
    state?.issue.is_creating_issue
  )
}
export const is_deleting_issue_busy = (state: { issue: issueSliceState }) => {
  return state?.issue.is_deleting_issue
}
export const is_loading_issue_busy = (state: { issue: issueSliceState }) => {
  return state?.issue.is_loading_issue
}
export const is_creating_issue_busy = (state: { issue: issueSliceState }) => {
  return state?.issue.is_creating_issue
}

export default issueSlice.reducer
